import 'slick-carousel';

export default {

	init() {

		$('.hamburger-icon').click(function() {
			$(this).toggleClass('open');
			$('header').toggleClass('open');

			if($(window).width() < 768) {
				if($(this).hasClass('open')) {
					$('.navbar-nav li').css({'opacity':1});
					$('.navbar-nav a').css({'opacity':1, 'transform': 'translateY(0)'});
				} else {
					$('.navbar-nav li').css({'opacity':0});
					$('.navbar-nav a').css({'opacity':0, 'transform': 'translateY(24px)'});
				}
			}
		});

		// Hide menu on scroll
		let c;
		let currentScrollTop = 0;
		let header = $('header');

		$(window).scroll(function () {
			let a = $(window).scrollTop();
			let b = header.height();

			currentScrollTop = a;

			// Do not hide menu if sub menu is open
			if( ! $('.hamburger-icon').hasClass('open')) {

				if (c < currentScrollTop && a > b + b) {
					header.addClass('hide-nav');
				} else if (c > currentScrollTop && !(a <= b)) {
					header.removeClass('hide-nav');
				}
			}
			c = currentScrollTop;
		});

		$(document).ready(function(){

			let padding = '';

			if( $(window).width() < 1080 && $(window).width() > 375 ) {
				padding = '18%';
			} else if( $(window).width() <= 375 ) {
				padding = '10%';
			} else {
				padding = '25%';
			}

			$('.admin-carousel').slick({
				dots: true,
				infinite: true,
				speed: 800,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: padding,
			});
		});

	},
	finalize() {
	// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js